import { ReduxActionTypes } from "constants/ReduxActionConstants";
import { createReducer } from "utils/ReducerUtils";

export interface AccountDeletionStateType {
  preflight: {
    loading: boolean;
    data: any | null;
  };
  deleteLoading: boolean;
}

const initialState: AccountDeletionStateType = {
  preflight: {
    loading: false,
    data: null,
  },
  deleteLoading: false,
};

export const accountDeletionReducer = createReducer(initialState, {
  [ReduxActionTypes.FETCH_ACCOUNT_DELETION_PREFLIGHT]: (
    state: AccountDeletionStateType,
  ) => ({
    ...state,
    preflight: { ...state.preflight, loading: true },
  }),
  [ReduxActionTypes.FETCH_ACCOUNT_DELETION_PREFLIGHT_SUCCESS]: (
    state: AccountDeletionStateType,
    action: { payload: any },
  ) => ({
    ...state,
    preflight: { loading: false, data: action.payload },
  }),
  [ReduxActionTypes.FETCH_ACCOUNT_DELETION_PREFLIGHT_FAILED]: (
    state: AccountDeletionStateType,
  ) => ({
    ...state,
    preflight: { loading: false, data: null },
  }),
  [ReduxActionTypes.DELETE_ACCOUNT]: (state: AccountDeletionStateType) => ({
    ...state,
    deleteLoading: true,
  }),
  [ReduxActionTypes.DELETE_ACCOUNT_SUCCESS]: (
    state: AccountDeletionStateType,
  ) => ({
    ...state,
    deleteLoading: false,
  }),
  [ReduxActionTypes.DELETE_ACCOUNT_FAILED]: (
    state: AccountDeletionStateType,
  ) => ({
    ...state,
    deleteLoading: false,
  }),
});
